import { PublicClientApplication } from "@azure/msal-browser";

export function createMsalInstance(
  clientId: string,
  tenantId: string,
  redirectUri: string,
): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
    },
  });
}
